import { Lang } from '../../Lang';
import { FormGroup2, Input2, LangTextV2, ModalDialog2, ModalDialogType2 } from 'bambooo';
/**
 * Create / rename a role (v2). System roles (root, user) can't be renamed —
 * the caller guards that; this dialog only edits the name.
 */
export class RoleEditModal extends ModalDialog2 {
    /**
     * Constructor
     */
    constructor() {
        super({ modalType: ModalDialogType2.large });
        this._id = 0;
        const bodyCard = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        jQuery('<h5 class="mb-3 text-primary"><i class="fas fa-user-tag mr-2"></i>Role</h5>').appendTo(bodyCard);
        const groupName = new FormGroup2({ label: new LangTextV2({ text: 'name' }) });
        groupName.appendTo(bodyCard);
        this._inputName = new Input2({});
        this._inputName.appendTo(groupName);
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save changes'), true);
    }
    /**
     * Set id
     * @param {number} id
     */
    setRoleId(id) {
        this._id = id;
    }
    /**
     * Return id
     * @return {number}
     */
    getRoleId() {
        return this._id;
    }
    /**
     * Set the name
     * @param {string} name
     */
    setName(name) {
        this._inputName.setValue(name);
    }
    /**
     * Return name
     * @return {string}
     */
    getName() {
        return this._inputName.getValue();
    }
    /**
     * Reset values
     */
    resetValues() {
        this.setRoleId(0);
        this.setName('');
    }
}
